export default __webpack_public_path__ + "static/media/icon-whatsapp.49be095e.svg";